
import { Vue, Options } from "vue-class-component";

import {AssociatedParty, BalanceSheet, BalanceSheetItem, Organization, Person, Third} from "@/types";
import store from "@/store";
import i18n from "@/i18n";
import { useRoute } from "vue-router";
import { formatDateLocale } from "@/utils/configuration/formatters-config";
import {removeExpandedItem} from "@/utils";

@Options({
  props: ["party", "tabPosition"],
  watch: {
    "$store.state.middleOfficeModule.section"(newValue) {
      this.showFinancialSituationExpense = newValue === `section-financialSituation${this.tabPosition}`;
    },
  },
  created() {

    if (this.party?.balanceSheets && this.party?.balanceSheets[0]?.supportingDocument) {
      store.dispatch("searchThirdModule/downloadFile", {
        request: this.party?.balanceSheets[0].supportingDocument.resourceUid,
        callback: (result: any) => {
          this.supportingDocument = result.originalFileName
        },
      })

    }
    this.balanceSheets = this.balanceSheetsList;
    if (this.balanceSheets && this.balanceSheets?.length > 0) {
      for(const balanceSheet of this.balanceSheets ){
        if( balanceSheet.supportingDocument){
          store.dispatch("searchThirdModule/downloadFile", {
            request: balanceSheet.supportingDocument.resourceUid,
            callback: (result:any) => {
              balanceSheet.supportingDocument=result
            },
          })
        }
        if (!balanceSheet.detail || balanceSheet.detail.length === 0) {
          balanceSheet.detail = store.getters["thirdModule/getBalanceSheetDetailInit"];
        }
      }
      this.isExpended = true;
    }
    else {
      this.addBalanceSheet();
      this.isExpended = true;
    }
  },
  computed: {
    isBalanceSheetBtnItemDisabled: function () {
      return !this.balanceSheetItemPlusBtn;
    },
    isBalanceSheetBtnDisabled: function () {
      return !this.financialSituationBtn;
    },
    balanceSheetsList: function () {
      this.balanceSheets =
          this.party.organization && this.party.organization.balanceSheets;
      if(this.balanceSheets.length>0 && !this.balanceSheets[0].status.label){this.balanceSheets[0].status.label=i18n.global.t(`party.role.new`)}
      return this.balanceSheets;
    },
  }
})
export default class PartyFinancialSituation extends Vue {
  party?: Third;
  tabPosition?: number;
  showFinancialSituationExpense = false;
  financialSituationBtn = false;
  balanceSheetItemPlusBtn = false;
  supportingDocument: any = null;
  statusLabel: any = null;
  balanceSheets: BalanceSheet[] = [];
  dateMask = "DD/MM/YYYY";
  detailsOpened=true;
  
  remove<T>(index: number, items: T[]) {
    if (items) {
      items.splice(index, 1);
    }
  }
  removeExpandedItem = removeExpandedItem;

  addExpandedBalanceSheet(items: BalanceSheet[]) {
    if (items && items.length === 0) {
      const element = store.getters["thirdModule/getBalanceSheetInit"];
      // Initialize with default details
      element.detail = store.getters["thirdModule/getBalanceSheetDetailInit"];
      this.balanceSheets?.push(element);
    }
  }
  
  showHideDetails(value: BalanceSheet) {
    if (!value.detail || value.detail.length === 0) {
      value.detail = store.getters["thirdModule/getBalanceSheetDetailInit"];
    }
  }
  
  addBalanceSheetItems(items: BalanceSheetItem[]) {
    const newItems = store.getters["thirdModule/getBalanceSheetDetailInitOne"];
    items.push(...newItems.map((item:any) => ({ ...item })));
  }

  
  addBalanceSheet() {
    const element = store.getters["thirdModule/getBalanceSheetInit"];
    element.detail = store.getters["thirdModule/getBalanceSheetDetailInit"];
    this.balanceSheets?.push(element);
  }

  get currentRoute() {
    return useRoute().name;
  }

  removeDetails<T>(index: number, items: T[]) {
    items.splice(index, 1);
  }

  get isdisable() {
    if (this.currentRoute !== 'TaskDetail') {
      return true
    } else
      return false
  }
  
  get isPartPro(){
    if (this.party?.roles?.some((role) => role?.role?.resourceUid === "SG")) {
      return true;
    }
    const managedOrganization = store.state.demandModule?.managedOrganization ?? [];
    return managedOrganization.some((associatedParty: any) =>
      associatedParty?.associatedParty?.role?.resourceUid === "SG"
      && associatedParty?.associatedParty?.third?.resourceUid === this.party?.resourceUid
    );
  }

  getNatureId(detail: any): string {
    return (detail?.nature?.id || detail?.nature?.resourceUid || "").toString();
  }

  isChiffreDAffaires(detail: any, index?: number): boolean {
    const id = this.getNatureId(detail).toLowerCase();
    if (id.includes("chiffre") || id.includes("affaire")) {
      return true;
    }
    return !id && index === 0;
  }

  isCapitalSocial(detail: any, index?: number): boolean {
    const id = this.getNatureId(detail).toLowerCase();
    if (id.includes("capital")) {
      return true;
    }
    return !id && index === 1;
  }

  isBilanDateRequired(detail: any, index?: number): boolean {
    return !this.isPartPro && this.isChiffreDAffaires(detail, index);
  }

  getNatureLabel(detail: any, index: number): string {
    if (this.isChiffreDAffaires(detail, index)) {
      return i18n.global.t("party.natureBalanceSheet.Chiffre_d_affaire");
    }
    if (this.isCapitalSocial(detail, index)) {
      return i18n.global.t("party.natureBalanceSheet.Capital_social");
    }
    return detail?.nature?.label || "";
  }

  getDetailDateLabel(detail: any, index: number): string {
    if (this.isChiffreDAffaires(detail, index)) {
      return i18n.global.t("middleOffice.party.organization.financialSituation.balanceSheetDate");
    }
    return i18n.global.t("main.labels.startDate");
  }

  formatDisplayDate(fullDate: any) {
    if (!fullDate) return '';
    const parts = fullDate.split('/');
    if (parts.length === 3) {
      return `${parts[1]} / ${parts[2]}`; // MM / YYYY
    }
    return '';
  }
  
  updateDate(value: any, detail: any) {
    if (!value) {
      detail.label = '';
      return;
    }
    
    const cleaned = value.replace(/\s/g, '');
    const parts = cleaned.split('/');
    
    if (parts.length === 2 && parts[0].length === 2 && parts[1].length === 4) {
      const month = parts[0];
      const year = parts[1];
      
      if (parseInt(month) >= 1 && parseInt(month) <= 12) {
        detail.label = `01/${month}/${year}`;
      }
    }
  }
    get isMO() {
    if (this.currentRoute !== 'TaskDetail') {
      return true
    } else
      return false
  }
  formatDateFrom(value: any) {
    if (value.period) {
      // For balance sheet items
      value.period.from = value.period.from.includes("/")
          ? formatDateLocale(value.period.from, "DD/MM/YYYY", "fr", "DD/MM/YYYY")
          : formatDateLocale(value.period.from, "DDMMYYYY", "fr", "DD/MM/YYYY");
    } else if (value.label) {
      // For detail items (using label as date field)
      value.label = value.label.includes("/")
          ? formatDateLocale(value.label, "DD/MM/YYYY", "fr", "DD/MM/YYYY")
          : formatDateLocale(value.label, "DDMMYYYY", "fr", "DD/MM/YYYY");
    }
  }
  
  formatDate(date: string) {
    return formatDateLocale(date, this.dateMask, "fr", "YYYY/MM/DD");
  }
  
  formatDateUntil(value: any) {
    value.period.until = value.period.until.includes("/")
        ? formatDateLocale(value.period.until, "DD/MM/YYYY", "fr", "DD/MM/YYYY")
        : formatDateLocale(value.period.until, "DDMMYYYY", "fr", "DD/MM/YYYY");
  }

  get countriesOptions() {
    return store.getters["picklistModule/countriesItems"];
  }
  
  get statusOptions() {
    return store.getters["picklistModule/roleStatusItems"].map((item: any) => {
      return {
        ...item,
        label: item.label?.toString() !== "" ? i18n.global.t("party.role." + item.value.toLowerCase()) : ''
      };
    }).sort((a: any, b: any) => a.label.localeCompare(b.label))
  }
  
  get requiredField() {
    return i18n.global.t("main.requiredField");
  }
}
